module.exports = __webpack_public_path__ + "img/telegram_logo.49aafe51.svg";